import PayeeCard from './PayeeCard';

export default PayeeCard;
